const Wrapper = require('../Wrapper');
const SelectricWrapper = require('../SelectricWrapper');

class SortingWrapper extends Wrapper {
    constructor(elementID) {
        super();

        this.element = document.getElementById(elementID);

        this.sortBy = new SelectricWrapper(document.getElementById('sortBy'));

        this.model = {
            sortBy: 'createdAt'
        };

        this.initEvents();
    }

    initEvents() {
        this.sortBy.addListener(() => {
            this.updateModel( { sortBy: this.sortBy.model.value })
        });
    }
}

module.exports = SortingWrapper;